/// <amd-module name="Agile/Common/Client/RestClient/Boards" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\boards\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import Boards = require("Agile/Common/Client/Contracts/Boards");

export interface IBoardsRestClient extends IVssRestClient {
    /**
     * Add a new board for the project.
     * 
     * @param postedBoard - Board definition.
     * @param project - Project ID or project name
     */
    createBoard(postedBoard: Boards.CreateBoard, project: string): Promise<Boards.BoardResponse>;
    /**
     * Deletes a board.
     * 
     * @param project - Project ID or project name
     * @param id - Board identifier.
     */
    deleteBoard(project: string, id: number): Promise<void>;
    /**
     * Returns information for a board given its unique identifier.
     * 
     * @param project - Project ID or project name
     * @param id - Board's unique identifier.
     */
    getBoard(project: string, id: number): Promise<Boards.BoardResponse>;
    /**
     * Get boards.
     * 
     * @param project - Project ID or project name
     * @param top - The maximum number of boards to get.
     * @param skip - The number of boards to skip.
     */
    getBoards(project: string, top?: number, skip?: number): Promise<Boards.BoardReference[]>;
    /**
     * Updates a board.
     * 
     * @param updatedBoard - New board data.
     * @param project - Project ID or project name
     * @param id - Id of the board to update.
     * @param eTag - Board Latest Changed Date
     */
    updateBoard(updatedBoard: Boards.UpdateBoard, project: string, id: number, eTag: String): Promise<Boards.BoardResponse>;
    /**
     * Creates a new column on a board.
     * 
     * @param boardColumn - Column data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    createBoardColumn(boardColumn: Boards.BoardColumnCreate, project: string, board: number): Promise<Boards.BoardColumnResponse>;
    /**
     * Deletes a column from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     * @param forceRemoveItems - Boolean indicating if items are to be force removed during the column delete.
     */
    deleteBoardColumn(project: string, board: number, id: string, forceRemoveItems: boolean): Promise<void>;
    /**
     * Gets column data for a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     */
    getBoardColumn(project: string, board: number, id: string): Promise<Boards.BoardColumnResponse>;
    /**
     * Get columns in a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    getBoardColumns(project: string, board: number): Promise<Boards.BoardColumnCollectionResponse>;
    /**
     * Updates a board column.
     * 
     * @param boardColumn - Column data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     * @param eTag - Column Latest Changed Date
     */
    updateBoardColumn(boardColumn: Boards.BoardColumnUpdate, project: string, board: number, id: string, eTag: String): Promise<Boards.BoardColumnResponse>;
    /**
     * Adds a single item to a board.
     * 
     * @param item - Item to add to the board.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    addBoardItem(item: Boards.NewBoardItem, project: string, board: number): Promise<Boards.BoardItemResponse>;
    /**
     * Gets data for a single board's item.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Item identifier.
     */
    getBoardItem(project: string, board: number, id: string): Promise<Boards.BoardItemResponse>;
    /**
     * Get items information for a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    getBoardItems(project: string, board: number): Promise<Boards.BoardItemCollectionResponse>;
    /**
     * Removes an item from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Board Item identifier to remove.
     */
    removeBoardItem(project: string, board: number, id: string): Promise<void>;
    /**
     * Updates a single item in a board.
     * 
     * @param updateItemDef - Updated item data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Update item id.
     * @param eTag - Item Latest Changed Date
     */
    updateBoardItem(updateItemDef: Boards.UpdateBoardItem, project: string, board: number, id: string, eTag: String): Promise<Boards.BoardItemResponse>;
    /**
     * Do an operation on a batch of items.
     * 
     * @param batchRequest - Data defining the batch operation.
     * @param project - Project ID or project name
     * @param board - The id of the board containing the items.
     */
    updateBoardItems(batchRequest: Boards.BoardItemBatchOperation, project: string, board: number): Promise<Boards.BoardItemCollectionResponse>;
    /**
     * Creates a new row on a board.
     * 
     * @param boardRow - Row data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    createBoardRow(boardRow: Boards.BoardRowCreate, project: string, board: number): Promise<Boards.BoardRowResponse>;
    /**
     * Deletes a row from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Row identifier.
     * @param forceRemoveItems - Boolean indicating if items are to be force removed during the row delete.
     */
    deleteBoardRow(project: string, board: number, id: string, forceRemoveItems: boolean): Promise<void>;
    /**
     * Gets a row given its identifier and board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Board row identifier.
     */
    getBoardRow(project: string, board: number, id: string): Promise<Boards.BoardRowResponse>;
    /**
     * Get rows in a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    getBoardRows(project: string, board: number): Promise<Boards.BoardRowCollectionResponse>;
    /**
     * Updates a board row.
     * 
     * @param boardRow - Row data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Row identifier.
     * @param eTag - Row Latest Changed Date
     */
    updateBoardRow(boardRow: Boards.BoardRowUpdate, project: string, board: number, id: string, eTag: String): Promise<Boards.BoardRowResponse>;
    /**
     * Creates a new sync for a column on a board.
     * 
     * @param boardSync - 
     * @param project - Project ID or project name
     * @param board - 
     * @param column - 
     */
    createBoardSyncAction(boardSync: Boards.BoardItemStateSyncCreate, project: string, board: number, column: string): Promise<Boards.BoardItemStateSync>;
}

class BoardsRestClient extends RestClientBase implements IBoardsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Add a new board for the project.
     * 
     * @param postedBoard - Board definition.
     * @param project - Project ID or project name
     */
    public async createBoard(
        postedBoard: Boards.CreateBoard,
        project: string
        ): Promise<Boards.BoardResponse> {

        return this.beginRequest<Boards.BoardResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{id}",
            routeValues: {
                project: project
            },
            body: postedBoard
        });
    }

    /**
     * Deletes a board.
     * 
     * @param project - Project ID or project name
     * @param id - Board identifier.
     */
    public async deleteBoard(
        project: string,
        id: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/boards/boards/{id}",
            routeValues: {
                project: project,
                id: id
            }
        });
    }

    /**
     * Returns information for a board given its unique identifier.
     * 
     * @param project - Project ID or project name
     * @param id - Board's unique identifier.
     */
    public async getBoard(
        project: string,
        id: number
        ): Promise<Boards.BoardResponse> {

        return this.beginRequest<Boards.BoardResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{id}",
            routeValues: {
                project: project,
                id: id
            }
        });
    }

    /**
     * Get boards.
     * 
     * @param project - Project ID or project name
     * @param top - The maximum number of boards to get.
     * @param skip - The number of boards to skip.
     */
    public async getBoards(
        project: string,
        top?: number,
        skip?: number
        ): Promise<Boards.BoardReference[]> {

        const queryValues: any = {
            '$top': top,
            '$skip': skip
        };

        return this.beginRequest<Boards.BoardReference[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{id}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Updates a board.
     * 
     * @param updatedBoard - New board data.
     * @param project - Project ID or project name
     * @param id - Id of the board to update.
     * @param eTag - Board Latest Changed Date
     */
    public async updateBoard(
        updatedBoard: Boards.UpdateBoard,
        project: string,
        id: number,
        eTag: String
        ): Promise<Boards.BoardResponse> {

        return this.beginRequest<Boards.BoardResponse>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/boards/boards/{id}",
            routeValues: {
                project: project,
                id: id
            },
            customHeaders: {
                "ETag": eTag,
            },
            body: updatedBoard
        });
    }

    /**
     * Creates a new column on a board.
     * 
     * @param boardColumn - Column data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async createBoardColumn(
        boardColumn: Boards.BoardColumnCreate,
        project: string,
        board: number
        ): Promise<Boards.BoardColumnResponse> {

        return this.beginRequest<Boards.BoardColumnResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{id}",
            routeValues: {
                project: project,
                board: board
            },
            body: boardColumn
        });
    }

    /**
     * Deletes a column from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     * @param forceRemoveItems - Boolean indicating if items are to be force removed during the column delete.
     */
    public async deleteBoardColumn(
        project: string,
        board: number,
        id: string,
        forceRemoveItems: boolean
        ): Promise<void> {

        const queryValues: any = {
            forceRemoveItems: forceRemoveItems
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            },
            queryParams: queryValues
        });
    }

    /**
     * Gets column data for a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     */
    public async getBoardColumn(
        project: string,
        board: number,
        id: string
        ): Promise<Boards.BoardColumnResponse> {

        return this.beginRequest<Boards.BoardColumnResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            }
        });
    }

    /**
     * Get columns in a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async getBoardColumns(
        project: string,
        board: number
        ): Promise<Boards.BoardColumnCollectionResponse> {

        return this.beginRequest<Boards.BoardColumnCollectionResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{id}",
            routeValues: {
                project: project,
                board: board
            }
        });
    }

    /**
     * Updates a board column.
     * 
     * @param boardColumn - Column data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Column identifier.
     * @param eTag - Column Latest Changed Date
     */
    public async updateBoardColumn(
        boardColumn: Boards.BoardColumnUpdate,
        project: string,
        board: number,
        id: string,
        eTag: String
        ): Promise<Boards.BoardColumnResponse> {

        return this.beginRequest<Boards.BoardColumnResponse>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            },
            customHeaders: {
                "ETag": eTag,
            },
            body: boardColumn
        });
    }

    /**
     * Adds a single item to a board.
     * 
     * @param item - Item to add to the board.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async addBoardItem(
        item: Boards.NewBoardItem,
        project: string,
        board: number
        ): Promise<Boards.BoardItemResponse> {

        return this.beginRequest<Boards.BoardItemResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{board}/items/{*id}",
            routeValues: {
                project: project,
                board: board
            },
            body: item
        });
    }

    /**
     * Gets data for a single board's item.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Item identifier.
     */
    public async getBoardItem(
        project: string,
        board: number,
        id: string
        ): Promise<Boards.BoardItemResponse> {

        return this.beginRequest<Boards.BoardItemResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/items/{*id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            }
        });
    }

    /**
     * Get items information for a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async getBoardItems(
        project: string,
        board: number
        ): Promise<Boards.BoardItemCollectionResponse> {

        return this.beginRequest<Boards.BoardItemCollectionResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/items/{*id}",
            routeValues: {
                project: project,
                board: board
            }
        });
    }

    /**
     * Removes an item from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Board Item identifier to remove.
     */
    public async removeBoardItem(
        project: string,
        board: number,
        id: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/boards/boards/{board}/items/{*id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            }
        });
    }

    /**
     * Updates a single item in a board.
     * 
     * @param updateItemDef - Updated item data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Update item id.
     * @param eTag - Item Latest Changed Date
     */
    public async updateBoardItem(
        updateItemDef: Boards.UpdateBoardItem,
        project: string,
        board: number,
        id: string,
        eTag: String
        ): Promise<Boards.BoardItemResponse> {

        return this.beginRequest<Boards.BoardItemResponse>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{project}/_apis/boards/boards/{board}/items/{*id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            },
            customHeaders: {
                "ETag": eTag,
            },
            body: updateItemDef
        });
    }

    /**
     * Do an operation on a batch of items.
     * 
     * @param batchRequest - Data defining the batch operation.
     * @param project - Project ID or project name
     * @param board - The id of the board containing the items.
     */
    public async updateBoardItems(
        batchRequest: Boards.BoardItemBatchOperation,
        project: string,
        board: number
        ): Promise<Boards.BoardItemCollectionResponse> {

        return this.beginRequest<Boards.BoardItemCollectionResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{board}/itemsbatch",
            routeValues: {
                project: project,
                board: board
            },
            body: batchRequest
        });
    }

    /**
     * Creates a new row on a board.
     * 
     * @param boardRow - Row data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async createBoardRow(
        boardRow: Boards.BoardRowCreate,
        project: string,
        board: number
        ): Promise<Boards.BoardRowResponse> {

        return this.beginRequest<Boards.BoardRowResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{board}/rows/{id}",
            routeValues: {
                project: project,
                board: board
            },
            body: boardRow
        });
    }

    /**
     * Deletes a row from a board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Row identifier.
     * @param forceRemoveItems - Boolean indicating if items are to be force removed during the row delete.
     */
    public async deleteBoardRow(
        project: string,
        board: number,
        id: string,
        forceRemoveItems: boolean
        ): Promise<void> {

        const queryValues: any = {
            forceRemoveItems: forceRemoveItems
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/boards/boards/{board}/rows/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            },
            queryParams: queryValues
        });
    }

    /**
     * Gets a row given its identifier and board.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Board row identifier.
     */
    public async getBoardRow(
        project: string,
        board: number,
        id: string
        ): Promise<Boards.BoardRowResponse> {

        return this.beginRequest<Boards.BoardRowResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/rows/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            }
        });
    }

    /**
     * Get rows in a board given its identifier.
     * 
     * @param project - Project ID or project name
     * @param board - Board identifier.
     */
    public async getBoardRows(
        project: string,
        board: number
        ): Promise<Boards.BoardRowCollectionResponse> {

        return this.beginRequest<Boards.BoardRowCollectionResponse>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{project}/_apis/boards/boards/{board}/rows/{id}",
            routeValues: {
                project: project,
                board: board
            }
        });
    }

    /**
     * Updates a board row.
     * 
     * @param boardRow - Row data.
     * @param project - Project ID or project name
     * @param board - Board identifier.
     * @param id - Row identifier.
     * @param eTag - Row Latest Changed Date
     */
    public async updateBoardRow(
        boardRow: Boards.BoardRowUpdate,
        project: string,
        board: number,
        id: string,
        eTag: String
        ): Promise<Boards.BoardRowResponse> {

        return this.beginRequest<Boards.BoardRowResponse>({
            apiVersion: "5.0-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/boards/boards/{board}/rows/{id}",
            routeValues: {
                project: project,
                board: board,
                id: id
            },
            customHeaders: {
                "ETag": eTag,
            },
            body: boardRow
        });
    }

    /**
     * Creates a new sync for a column on a board.
     * 
     * @param boardSync - 
     * @param project - Project ID or project name
     * @param board - 
     * @param column - 
     */
    public async createBoardSyncAction(
        boardSync: Boards.BoardItemStateSyncCreate,
        project: string,
        board: number,
        column: string
        ): Promise<Boards.BoardItemStateSync> {

        return this.beginRequest<Boards.BoardItemStateSync>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/boards/boards/{board}/columns/{column}/syncActions/{id}",
            routeValues: {
                project: project,
                board: board,
                column: column
            },
            body: boardSync
        });
    }

}

export const BoardsClientName = "IBoardsRestClient";

export function getBoardsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IBoardsRestClient {
    return pageContext.getRestClient<IBoardsRestClient>(BoardsClientName, options);
}

RestClients.add(BoardsClientName, { 
    factory: BoardsRestClient,
    options: {
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
